import { useEffect, useState } from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography
} from "@material-ui/core";
import {
  ShoppingBag as ShoppingBagIcon,
  Monitor as MonitorIcon,
  // User as UserIcon,
  Users as UsersIcon,
  Database as DataBaseIcon,
  Calendar as CalendarIcon,
  PieChart as PieChartIcon,
  Sliders as SlidersIcon
} from "react-feather";
import { jwtDecode } from "jwt-decode";
import NavItem from "./NavItem";
import useAuth from "../hooks/useAuth";

const items = [
  {
    href: "/app/dashboard",
    icon: MonitorIcon,
    title: "Trang chủ"
  },
  {
    href: "/app/accounts",
    icon: UsersIcon,
    title: "Tài khoản"
  },
  {
    href: "/app/tin-chap",
    icon: SlidersIcon,
    title: "Tín chấp"
  },
  {
    href: "/app/tra-gop",
    icon: PieChartIcon,
    title: "Trả góp"
  },
  {
    href: "/app/chi-hoat-dong",
    icon: ShoppingBagIcon,
    title: "Quản lý thu chi"
  },
  {
    href: "/app/gop-von",
    icon: DataBaseIcon,
    title: "Quản lý nguồn vốn"
  },
  {
    href: "/app/bao-cao",
    icon: CalendarIcon,
    title: "Báo cáo lịch sử ghi nhận"
  }
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const { user = "" } = useAuth();
  const [userObj, setUserObj] = useState({});
  useEffect(() => {
    if (user && typeof user === "string") {
      const cloneUser = jwtDecode(user);
      setUserObj(cloneUser);
    } else if (user && typeof user === "object") {
      setUserObj(user);
    }
  }, [user]);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%"
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          p: 2
        }}
      >
        <Avatar
          component={RouterLink}
          sx={{
            cursor: "pointer",
            width: 64,
            height: 64
          }}
          to="/app/account"
        >
          {userObj?.userName?.slice(0, 2).toUpperCase()}
        </Avatar>
        <Typography color="textSecondary" variant="body2">
          {userObj?.role}
        </Typography>
      </Box>

      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {items.map(item => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 64,
              height: "calc(100% - 64px)"
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default DashboardSidebar;
